export default "__VITE_ASSET__BFN7rfTS__"